import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { BiWifi, BiWifiOff } from 'react-icons/bi';
import { useConnectionContext } from '../../../contexts/connection/connectionContext';
import { UserGlobalContextMemorySpace } from '../../../contexts/user/userGlobalContext';
import './style.scss';

/**
 * Modal que se muestra cuando se detecta pérdida de conexión a internet
 * Informa al usuario sobre el problema de conectividad y proporciona opciones
 */
export const ConnectionModal = () => {
  const { showConnectionModal, closeConnectionModal, retryConnection, isOnline, isRetrying } = useConnectionContext();
  const { sitePSHB } = useContext(UserGlobalContextMemorySpace);

  const handleRetry = () => {
    retryConnection();
  };

  const handleClose = () => {
    closeConnectionModal();
  };

  // Determinar el sitio para aplicar estilos apropiados
  const siteStyle = sitePSHB ? "pshb-style" : "hb-style";

  return (
    <Modal
      size="md"
      aria-labelledby="connection-modal-title"
      show={showConnectionModal}
      centered
      onHide={handleClose}
      backdrop="static" // No permite cerrar clickeando fuera
      keyboard={false} // No permite cerrar con ESC
    >
      <div className={siteStyle}>
        <div className="connection-modal-content">
          <Modal.Body className="connection-modal-body">
            <div className="connection-status-container">
              <div className="connection-icon-container">
                {isOnline ? (
                  <BiWifi size="60px" className="connection-icon online" />
                ) : (
                  <BiWifiOff size="60px" className="connection-icon offline" />
                )}
              </div>
              
              <div className="connection-message">
                <h4 className="connection-title">
                  {isOnline ? 'Conexión restaurada' : 'Sin conexión a internet'}
                </h4>
                <p className="connection-description">
                  {isOnline 
                    ? 'Tu conexión a internet se ha restaurado correctamente.'
                    : 'Por favor, revisá tu conexión y volvé a intentarlo.'
                  }
                </p>
              </div>

              <div className="connection-actions">
                {isOnline ? (
                  <button 
                    className="button-continuar connection-button"
                    onClick={handleClose}
                  >
                    Continuar
                  </button>
                ) : (
                  <div className="connection-buttons-group">
                    <button 
                      className="button-secondary connection-button"
                      onClick={handleClose}
                      disabled={isRetrying}
                    >
                      Cerrar
                    </button>
                    <button 
                      className="button-continuar connection-button retry-button"
                      onClick={handleRetry}
                      disabled={isRetrying}
                    >
                      {isRetrying ? (
                        <>
                          <span className="spinner-grow spinner-grow-sm me-2"></span>
                          Verificando...
                        </>
                      ) : (
                        'Volver a intentar'
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </Modal>
  );
};
